import ReactGA from 'react-ga4'
import { Parallax } from 'react-scroll-parallax'
import { heroHeading, heroSubheading } from '../data/hero'
import { scrollToId } from '../theme/utils'

export default function Hero() {
  return (
    <section
      id="hero"
      className="container mx-auto max-w-7xl px-0 py-0 sm:px-4 sm:py-4"
    >
      <div className="fit-content relative h-[600px] overflow-hidden pt-24 sm:h-[450px] md:h-[400px] lg:h-[500px]">
        {/* Parallaxed image */}
        <Parallax
          translateY={[-45, 15]}
          disabled={false}
          className="absolute inset-0 z-0"
        >
          <picture>
            <source
              type="image/webp"
              srcSet="/media/hero/strangeways_2025_320.webp 320w, 
              /media/hero/strangeways_2025_480.webp 480w, 
              /media/hero/strangeways_2025_640.webp 640w, 
              /media/hero/strangeways_2025_768.webp 768w, 
              /media/hero/strangeways_2025_960.webp 960w, 
              /media/hero/strangeways_2025_1200.webp 1200w"
              sizes="100vw"
            />
            <img
              src="/media/hero/strangeways_2025_768.webp"
              alt="Hero image of a cool room"
              className="h-full w-full scale-100 object-cover object-[center_60%]"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </picture>
        </Parallax>

        {/* Gradient overlay - stronger for better text readability */}
        <div
          className="bg-linear-to-t pointer-events-none absolute inset-0 z-10 from-gray-300 via-white/85 to-white/40 dark:from-gray-900 dark:via-neutral-950/70 dark:to-transparent"
          aria-hidden="true"
        />

        {/* Content */}
        <div className="relative z-20 flex h-full max-w-3xl items-end px-4 pb-8 sm:px-6">
          <div className="space-y-4">
            {heroHeading.heading && (
              <h1 className="lg:text-4xl max-w-md text-3xl font-bold tracking-tight text-neutral-900 drop-shadow-sm dark:text-white dark:drop-shadow-md sm:text-3xl">
                {heroHeading.heading}
              </h1>
            )}
            {heroHeading.paragraph && (
              <p className="text-base sm:text-md lg:text-lg max-w-2xl leading-relaxed text-neutral-800 dark:text-neutral-200">
                {heroHeading.paragraph}
              </p>
            )}
            <div className="flex gap-3 pt-2">
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault()
                  scrollToId('booking')
                  ReactGA.event({
                    category: 'Button Click',
                    action:
                      'User clicked the explore sessions button in the Hero Section',
                    label: 'Hero Section',
                  })
                }}
                className="text-sm inline-flex cursor-pointer items-center rounded-full border border-neutral-400 bg-white px-5 py-2.5 font-semibold text-neutral-900 shadow-sm transition-all hover:bg-neutral-100 hover:shadow-md dark:border-neutral-600 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800"
              >
                Explore sessions
              </a>
            </div>
            <p className="text-sm pt-1 font-medium text-neutral-600 dark:text-neutral-400">
              {heroSubheading.map((sub, index) =>
                index < heroSubheading.length - 1 ? `${sub} · ` : sub
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
